import { render, staticRenderFns } from "./SearchPanel.vue?vue&type=template&id=804b1b62&scoped=true"
import script from "./SearchPanel.vue?vue&type=script&lang=js"
export * from "./SearchPanel.vue?vue&type=script&lang=js"
import style0 from "./SearchPanel.vue?vue&type=style&index=0&id=804b1b62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804b1b62",
  null
  
)

export default component.exports